import axios from 'axios';
import { WAPIAddress } from 'constants/config';
import * as wapiKeys from '../../../apiKeys';

const wapiKey = process.env.APP_ENV === 'development'? wapiKeys.dev_key : wapiKeys.prod_key;

export default function getUserInfo() {

  return new Promise((resolve, reject) => {
    axios.put(WAPIAddress, {'uri': '/user_info/',
      'method': 'GET',
      'token': localStorage.getItem('token'),
      'wapiKey': wapiKey,
    })
      .then((res) => {
        resolve(res.data);
      })
        .catch((err) => {
          reject(err);
        })
  })
}


// WEBPACK FOOTER //
// ./src/controllers/controllers/user/getUserInfo.js